import { IMTicketDetails } from '../types';

export const EMPTY_MTICKET_INFO: IMTicketDetails = {
  email: '',
  mobile: '',
  startDate: undefined,
};
